<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

export default {
  page: {
    title: "Termly Promotion",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Termly Promotion",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Promotion",
          active: true,
        },
      ],
      filterStds: {
        class: "",
        term: "",
        toTerm: "",
      },
      pageErrors: {
        promotion: "",
      },
    };
  },
  computed: {
    ...mapGetters("classes", [
      "AllStreams",
      "AllClasses",
      "AllClassStreams",
      "SaveStatus",
      "getPromotedStudents",
      "getFilterdTermPromotions",
      "promotionStatus",
      "getNextTermStudents",
    ]),
    ...mapGetters("marks", ["getYears"]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  methods: {
    ...mapActions({
      FetchClasses: "classes/fetchClasses",
      FetchStreams: "classes/fetchStreams",
      FetchClassStreams: "classes/fetchClassStreams",
      FetchYears: "marks/fetchYear",
      TermlyPromoteStudents: "classes/termlyPromoteStudents",
      PromoteFailedStudents: "classes/promoteFailedStudents",
      FilterTermlyPromotionStudents: "classes/filterTermlyPromotionStudents",
      FetchNextClassStudents: "classes/fetchNextClassStudents",
    }),
    submitPromotion() {
      if (this.getFilterdTermPromotions.promotedStd.length > 0) {
        this.TermlyPromoteStudents({
          studentDetails: this.getFilterdTermPromotions.promotedStd,
          promotionDetails: this.filterStds,
        });
      }
    },
    filterStudents() {
      this.checkTerms(this.filterStds.term, this.filterStds.toTerm);
      this.FilterTermlyPromotionStudents(this.filterStds);
    },
    //fetch next class students
    nextTermStudents() {
      this.filterStds.nextClassFetch = 1;
      this.FetchNextTermStudents(this.filterStds);
    },

    checkSelectedTerm() {
      this.checkTerms(this.filterStds.term, this.filterStds.toTerm);
    },

    //check if promotion and current classes are not the same
    checkTerms(from, to) {
      console.log(from, ",", to);
      if (to != "" && parseInt(to) != parseInt(from) + 1) {
        this.pageErrors.promotion =
          "Promotion Terms should be different from the current Term";
      } else {
        this.pageErrors.promotion = "";
      }
    },

    setYear() {
      this.filterStds.year = new Date().getFullYear();
    },
  },
  created() {
    this.FetchYears();
    this.FetchClasses();
    this.FetchStreams();
    this.setYear();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('student_promotion')
        )
      "
    >
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              <button
                v-if="promotionStatus"
                name=""
                id=""
                class="btn float-end btn-sm btn-secondary"
                disabled
                role="button"
              >
                <b-spinner
                  class="text-white"
                  small
                  label="Fetching Data..."
                ></b-spinner>
                Promoting Students...
              </button>
              <button
                v-else-if="
                  !this.getFilterdTermPromotions.promotedStd ||
                    getFilterdTermPromotions.promotedStd.length < 1
                "
                name=""
                id=""
                class="btn float-end btn-sm btn-secondary"
                disabled
                role="button"
              >
                Promote Students
                <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
              </button>
              <button
                v-else
                name=""
                id=""
                class="btn float-end btn-sm btn-secondary"
                href="#"
                @click="submitPromotion()"
                role="button"
              >
                Promote Students
                <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>
              </button>
            </div>
            <h6 class="card-title">Select Students For Next Term</h6>
            <hr />
            <form @submit.prevent="filterStudents()">
              <div class="row mb-4">
                <div class="form-group col-md-6 mt-2">
                  <div class="form-group">
                    <select
                      class="form-control form-control-sm"
                      required
                      v-model="filterStds.class"
                      name=""
                      id=""
                    >
                      <option value="" selected disabled>Select Class</option>
                      <option
                        v-for="(classes, index) in AllClasses"
                        :key="index"
                        :value="classes.id"
                      >
                        {{ classes.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group col-md-6 mt-2">
                  <div class="form-group">
                    <select
                      class="form-control form-control-sm"
                      required
                      v-model="filterStds.term"
                      name=""
                      id=""
                      @change="checkSelectedTerm"
                    >
                      <option value="" selected disabled>From Term</option>
                      <option value="1">Term 1</option>
                      <option value="2">Term 2</option>
                    </select>
                  </div>
                </div>
                <div class="form-group col-md-6 mt-2">
                  <div class="form-group">
                    <select
                      :class="
                        pageErrors.promotion
                          ? 'form-control form-control-sm is-invalid'
                          : 'form-control form-control-sm'
                      "
                      required
                      v-model="filterStds.toTerm"
                      name=""
                      id=""
                      @change="checkSelectedTerm"
                    >
                      <option value="" selected disabled>To Term</option>
                      <option value="2">Term 2</option>
                      <option value="3">Term 3</option>
                    </select>
                  </div>
                  <small v-if="pageErrors.promotion" class="text-danger">
                    {{ pageErrors.promotion }}</small
                  >
                </div>
                <div class="col-md-6 mt-2">
                  <button
                    type="submit"
                    size="sm"
                    disabled
                    class="btn btn-sm btn-outline-primary"
                    v-if="SaveStatus"
                  >
                    <b-spinner
                      variant="primary"
                      small
                      label="Fetching Data..."
                    ></b-spinner>
                    Fetching Students...
                  </button>
                  <button
                    v-else-if="pageErrors.promotion != ''"
                    type="submit"
                    disabled
                    size="sm"
                    class="btn btn-sm btn-outline-primary"
                  >
                    <i class="fa fa-filter" aria-hidden="true"></i>
                    Filter Students
                  </button>
                  <button
                    v-else
                    type="submit"
                    size="sm"
                    class="btn btn-sm btn-outline-primary"
                  >
                    <i class="fa fa-filter" aria-hidden="true"></i>
                    Filter Students
                  </button>
                </div>
              </div>
            </form>
            <div class="row">
              <div class="col-md-6">
                <span class="text-muted"
                  ><strong>Selected Class: </strong>
                  {{
                    getFilterdTermPromotions.details
                      ? getFilterdTermPromotions.details.class.name
                      : ""
                  }}</span
                >
              </div>
              <div class="col-md-6">
                <span class="text-muted"
                  ><strong>Current Term: </strong>
                  {{
                    getFilterdTermPromotions.details
                      ? "Term " + getFilterdTermPromotions.details.fromTerm
                      : ""
                  }}</span
                >
              </div>
              <div class="col-md-6 mt-2">
                <span class="text-muted"
                  ><strong>Promotion Term: </strong>
                  {{
                    getFilterdTermPromotions.details
                      ? "Term " + getFilterdTermPromotions.details.toTerm
                      : ""
                  }}</span
                >
              </div>
              <div class="col-md-6 mt-2">
                <span class="text-muted"
                  ><strong>Current Year: </strong>
                  {{
                    getFilterdTermPromotions.details
                      ? getFilterdTermPromotions.details.year
                      : ""
                  }}</span
                >
              </div>
            </div>

            <hr />
            <div class="row">
              <strong> Students Ready For Promotion</strong>
              <div class="row mt-3">
                <div
                  class="text-muted col-md-6 mt-0"
                  v-for="(student,
                  index) in getFilterdTermPromotions.promotedStd"
                  :key="index"
                >
                  <p class="mb-0">
                    <i
                      class="fa fa-check align-middle text-success me-1"
                      style="font-size: 8px"
                      aria-hidden="true"
                    ></i>
                    {{ student.student.name }} ({{ student.streamx.name }})
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              <h5 class="text-primary">
                List of Students in The Selected Class
              </h5>
              <hr />
            </div>
            <div class="row">
              <div class="col-lg-9 col-sm-8">
                <div class="text-muted">
                  <p
                    class="mb-1"
                    v-for="(student, index) in getNextTermStudents.promotedStd"
                    :key="index"
                  >
                    <i
                      class="
                        mdi mdi-circle-medium
                        align-middle
                        text-primary
                        me-1
                      "
                    ></i>
                    {{ student.student.name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
